module.exports = __webpack_public_path__ + "static/img_4901-115a62d041ed8b26f46a220fde45acce.webp";